import { getRecoil, setRecoil } from "recoil-nexus";
import myInfoState from "../../atoms/myinfo";
import { socket } from "../index";
import { UserDetail } from "../type";

interface ListenReceiveMyInfoPayload {
  id: string,
  ownRoomName: string | null,
  ownRoomId: string | null,
  userDetail: UserDetail | null,
  bullet: number,
  standardTicket: number,
  premiumTicket: number,
}

const listenReceiveMyInfo = () => {
  socket?.on('RECEIVE_MYINFO', (payload: ListenReceiveMyInfoPayload) => {
    const myInfo = getRecoil(myInfoState);
    setRecoil(myInfoState, {
      ...myInfo,
      ...payload,
    });
  });
}

export default listenReceiveMyInfo;